// The olive plans: one list for /pricing's cards and the plan cards on /settings/billing.
// Plain data (no 'use client'), so server components can read it too; byokPlanData.ts is its fal-key twin.

import { SALES_FORM_URL } from '@/lib/salesForm'

export interface OlivePlanFeature {
  label: string
  tooltip?: string
  /** Monthly olive allowance — renders a computed outcomes tooltip instead of a static one */
  monthlyOlives?: number
}

export type PricingPlanId = 'default' | 'pro' | 'studio' | 'enterprise'

export interface OlivePlanCard {
  name: string
  planId: PricingPlanId
  price: string
  priceSuffix?: string
  tagline: string
  cta: string
  href: string
  highlighted?: boolean
  badge?: string
  features: OlivePlanFeature[]
}

export const OLIVE_PLAN_CARDS: OlivePlanCard[] = [
  {
    name: 'Indie',
    planId: 'default',
    price: 'Free',
    tagline: 'For passion projects',
    cta: 'Request Access',
    href: 'https://form.typeform.com/to/VVwyeUrj',
    // Short labels per card; the comparison table carries the detail.
    features: [
      { label: 'Pay-as-you-go olives' },
      {
        label: 'MCP and CLI',
        tooltip: 'Connect any AI agent or your own scripts. The generation API comes with your own fal key.',
      },
      { label: 'Public projects' },
    ],
  },
  {
    name: 'Pro',
    planId: 'pro',
    price: '$30',
    priceSuffix: '/mo',
    tagline: 'For solo professionals',
    highlighted: true,
    cta: 'Request Access',
    href: 'https://form.typeform.com/to/VVwyeUrj',
    features: [
      { label: '300 olives / mo ($30)', monthlyOlives: 300 },
      { label: 'Private projects' },
      { label: 'Early access to new features' },
    ],
  },
  {
    name: 'Studio',
    planId: 'studio',
    price: '$150',
    priceSuffix: '/mo',
    tagline: 'For teams',
    cta: 'Request Access',
    href: 'https://form.typeform.com/to/VVwyeUrj',
    features: [
      { label: '1,500 olives / mo ($150)', monthlyOlives: 1500 },
      { label: 'Team and permissions' },
      { label: 'Olive spend per project' },
    ],
  },
  {
    name: 'Enterprise',
    planId: 'enterprise',
    price: 'Custom',
    tagline: 'For bespoke solutions',
    cta: 'Contact Us',
    href: SALES_FORM_URL,
    features: [
      { label: 'Custom olives' },
      { label: 'Billing access for finance' },
      { label: 'SLAs and integrations' },
      {
        label: 'Hands-on production support',
        tooltip: 'Pipeline, production and creative help from our creative technologists, shaped around your team.',
      },
    ],
  },
]
